import { fromJS } from 'immutable'
import {
  LOB_LIST_REQUEST,
  LOB_LIST_SUCCESS,
  LOB_LIST_FAILURE,
  LOB_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LOB_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case LOB_LIST_SUCCESS:
      return state
        .set('lobs', fromJS(action.payload.LOBs))
        .set('isFetching', false)
    case LOB_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LOB_LIST_RESET:
      return state
        .delete('lobs')
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lob/lob-list-reducer.js